import React, { FC } from 'react';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { loadSingleBatch } from '@reducers/batch';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface ProductionOrderDetailsPartTimelineProps extends ProductionOrderScreenProps {
}

const ProductionOrderDetailsPartTimelineComponent: FC<ProductionOrderDetailsPartTimelineProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.part}>
      <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsPartTimeline = connect(null, {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsPartTimelineComponent);

export { ProductionOrderDetailsPartTimeline };
